



























import { Component, Prop, Emit, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { traderStore } from '@/utils/store-accessor'
import { AtomTextField } from '@/components/atoms'
import ModalTrader from '@/components/modals/ModalTrader/ModalTrader.vue'
import { defaultTrader, Trader } from '@/api'
import { MaskPattern } from '@/types'
import { cloneDeep } from 'lodash'

@Component({
  components: {
    ModalTrader
  }
})
export default class InputCodeTrader extends ComponentVue {
  @Ref()
  textField!: AtomTextField

  @Ref()
  modalTrader!: ModalTrader

  @Prop({ type: String })
  label!: string

  @Prop({ type: String })
  placeholder!: string

  @Prop({ type: String })
  value!: string

  @Prop({
    type: Boolean,
    default: false
  })
  hideName!: boolean

  @Prop({
    type: Boolean,
    default: true
  })
  hideDetails!: boolean

  @Prop({ type: Boolean, default: false })
  error!: boolean

  @Prop({ type: String, default: '' })
  errorMessage!: string

  @Prop({
    type: Boolean,
    default: false
  })
  multiple!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  get mask(): string {
    return this.multiple ? MaskPattern.HalfWidthOnly : 'X'.repeat(4)
  }

  get defaultCodes(): string[] {
    return this.value
      .split(',')
      .filter(
        (value, index, array) => value !== '' && array.indexOf(value) === index
      )
  }

  get name(): string {
    if (this.multiple || this.hideName) return ''
    return traderStore.findByCode(this.value)?.shortName ?? ''
  }

  onInput(value: string) {
    this.$emit('input', value)
    const item = traderStore.allItems.find(item => item.code === value)
    this.$emit(
      'input:trader',
      item !== undefined
        ? cloneDeep(item)
        : Object.assign(defaultTrader(), { code: value })
    )
  }

  onModalTraderInput(item: Trader | Trader[]) {
    if (Array.isArray(item)) {
      this.$emit('input', item.map(value => value.code).join(','))
      return
    }

    this.$emit('input', item.code)
    this.$emit('input:trader', item)
  }

  @Emit('click:list')
  onListClick(): void {
    this.modalTrader.open()
  }

  @Emit('keydown:enter')
  onKeydownEnter() {}
}
